import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCinema4dComponent } from './simple-icons-cinema4d.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCinema4dComponent ],
    exports:      [ SimpleIconsCinema4dComponent ],
    bootstrap:    []
})
export class SimpleIconsCinema4dModule {}
